import { navigationNamespace } from "@/store/modules/navigation";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class SvgIcon extends Vue {
  @Getter("darkMode", navigationNamespace)
  darkMode!: boolean;

  @Prop(String)
  src!: string;

  get computedPath() {
    const parts = this.src.split(".");
    this.blink = parts[1] === "gif";

    // Luke...stay away
    const darkPath = this.darkMode ? "dark/" : "";
    return "./img/icons/" + darkPath + parts[0] + ".svg";
  }

  blink = false;
}
